<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-card width="600" class="px-5 py-3">
        <v-card-title class="text-center clean">
           <v-spacer />{{ $t('export') }}<v-spacer />
        </v-card-title>
        <v-overlay class="waitoverlay" :value="loading">
          <v-progress-circular
            indeterminate
            size="64"
            class="mr-4"
          /> {{ $t('global.loading') }}
      </v-overlay>
        <v-card-text>
          <date-range-picker :text-color="datePickerColor" @datesChange="exportDataDatesChanged" />
          <v-select
            v-model="selectedScope"
            item-text="text"
            :items="scopeLocalised"
            item-value="value"
            :label="$t('scope')"
            />
            <v-select
              v-if="!loading && selectedScope!==null"
              v-model="key"
              :items="keySelect"
              item-text="text"
              item-value="value"
              :label="selectedScope"
            />
             <v-text-field
             v-show="showKey"
             v-model="key"
            color="secondary"
            :label="$t('key')"
          />
          <v-select
            v-model="selectedFormat"
            item-text="text"
            :items="formats"
            item-value="value"
            :label="$t('format')"
            />
          <v-switch
            v-if="isSuperUser"
            v-model="anonymise"
            :disabled="disableAnonymiseButton"
            :label="$t('anonymise-data') "
            inset
          />
        </v-card-text>
        <v-card-actions class="text-center">
           <v-spacer /><v-btn
          class="center"
            color="blue"
            :disabled="disabledExportButton"
            @click="exportData"
          >
          {{ $t('export') }}
            </v-btn><v-spacer />
        </v-card-actions>
      </v-card>
   </v-row>
   <v-row justify="center">
   <v-card v-if="error" color="red" width="400" class="px-5 py-3 text-center">
            {{ error }}<br>
      </v-card>
   </v-row>
   <v-overlay :value="busy">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>
<script>
  import moment from 'moment'
  import api from '@/helpers/api.js'
  import { Users, Roles } from '@/helpers/users.js'
  import DateRangePicker from './DateRangePicker'
  export default {
    name: 'RawExport',
    components: {
      'date-range-picker': DateRangePicker,
    },
    data () {
      return {
        busy: false,
        anonymise: false,
        disableAnonymiseButton: !this.$store.getters.userHasRole(Roles.SUPER),
        readyToDownload: false,
        key: null,
        rawData: null,
        error: '',
        pickerLabel: 'Start Date',
        startDate: moment().startOf('month').toDate(),
        endDate: moment().endOf('month').toDate(),
        datePickerColor: 'blacktext',
        selectedScope: null,
        selectedFormat: 'csv',
        scope: ['Account', 'Class', 'User', 'Consent'],
        formats: ['csv', 'json'],
        keySelect: [],
        loading: false,
      }
    },
    computed: {
      isSuperUser () {
        return this.$store.getters.currentUserProfile.user.roles.includes(Roles.SUPER)
      },
      showKey () {
        const issuper = this.$store.getters.currentUserProfile.user.roles.includes(Roles.SUPER)
        // const visible = this.selectedScope
        return issuper
      },
      disabledExportButton () {
        return !this.selectedScope || !this.key || !this.selectedFormat
      },
      scopeLocalised () {
        const i = this.scope.map((x) => {
          return { value: x, text: this.$t('dataexport.scope-type.' + x) }
        })
        return i
      },
    },
    watch: {
      async selectedScope (newScope, oldScope) {
        // if (this.isSuperUser) return
        this.key = null
        this.keySelect = []
        this.loading = true
        if (newScope === 'Account') {
          this.keySelect = [{ text: this.$store.getters.currentUserProfile.account.displayName, value: this.$store.getters.currentUserProfile.account.id }]
          this.key = this.$store.getters.currentUserProfile.account.id
        }
        if (newScope === 'Class') {
          const classes = await api.getClasses()
          this.keySelect = classes.classes.map((x) => { return { text: x.name, value: x.id } })
          this.key = this.keySelect[0]?.value
        }
        if (newScope === 'User') {
          const users = await Users.Get()
          this.keySelect = users.map((x) => { return { text: x.displayName, value: x.id } })
          this.key = this.keySelect[0]?.value
        }
        if (newScope === 'Consent') {
          const agreements = await api.getAgreements()
          this.keySelect = agreements.map((x) => { return { text: x.key, value: x.key } })
          this.key = this.keySelect[0]?.value
        }
        this.loading = false
      },
    },
    methods: {
      exportDataDatesChanged (date) {
        this.startDate = date[0]
        this.endDate = date[1]
      },
      async exportData () {
        try {
          this.busy = true
          this.rawData = await api.getEventCollections(this.startDate, this.endDate, this.selectedScope, this.key, this.selectedFormat, this.anonymise)
          this.downloadExportedData()
          this.readyToDownload = true
          this.busy = false
          this.error = ''
        } catch (err) {
          this.readyToDownload = true
          this.busy = false
          console.log('Extraction Failed: ' + err.message + ' ' + err.stack)
          this.error = err.response.data
        }
      },
      downloadExportedData () {
        if (this.selectedFormat === 'csv' && typeof this.rawData === 'string') {
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.rawData)
          anchor.target = '_blank'
          const date = moment().format('YYMMDD')
          let name = this.keySelect.find(x => x.value === this.key)?.text
          if (!name) name = `${this.selectedScope}_${this.key}`
          anchor.download = `DataExport_${name}_${date}.csv`
          anchor.click()
        } else if (this.selectedFormat === 'json' && Array.isArray(this.rawData)) {
          const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.rawData))
          const downloadAnchorNode = document.createElement('a')
          downloadAnchorNode.setAttribute('href', dataStr)
          downloadAnchorNode.setAttribute('download', 'Exported Data' + '.json')
          document.body.appendChild(downloadAnchorNode)
          downloadAnchorNode.click()
          downloadAnchorNode.remove()
        }
      },
    },
  }
</script>
